import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'
import { customPropTypes } from 'tools/react'
import { colorConstants, iconSizes, iconSizesInPixel } from 'theme/default'
import Component from 'decorators/Component'

class BaseIcon extends React.PureComponent {
  static propTypes = {
    IconComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    iconSize: customPropTypes.oneOfObjectKeys(iconSizes),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fill: PropTypes.string.isRequired
  }

  static defaultProps = {
    iconSize: 'medium',
    fill: colorConstants.black
  }

  render () {
    const { IconComponent, height, width, iconSize, fill, ...props } = this.props
    const iconHeight = height || iconSizesInPixel[iconSize]
    const iconWidth = width || iconSizesInPixel[iconSize]

    return (
      <IconComponent fill={fill} height={iconHeight} width={iconWidth} {...props} />
    )
  }
}

export default (IconComponent) => Component()(
  withTheme(({ theme = {}, ...props }) => <BaseIcon fill={theme.colorHeadingsFont} IconComponent={IconComponent} {...props} />)
)
